import { useSession } from 'next-auth/react';

export const useNextAuthAuthHeader = (): Record<string, string> => {
    const { data: session } = useSession();
  
    if (session?.id_token) {
      return { Authorization: `Bearer ${session.id_token}` };
    }
  
    return {};
};